<kendo-timepicker
  scrollPicker
  [format]="format()"
  [steps]="steps()"
  (focus)="inputFocus.emit($event)"
  (focusin)="focus()"
  (focusout)="blur()"
  placeholder=""
  [formControl]="$any(_control)"
  [clearButton]="showClear()"
  [popupSettings]="{
    appendTo: appendTo(),
    popupClass: popupClass(),
  }"
  [min]="min()"
  [max]="max()"
>
  <kendo-datetimepicker-messages
    accept="{{ translation.leftMenu.accept | transloco }}"
    cancel="{{ translation.leftMenu.cancel | transloco }}"
  />
</kendo-timepicker>
